import { IconOtherClose } from '@doltech/icons/IconOtherClose';
import { Button } from '@doltech/ui/lib/figma/ButtonV2/ButtonV2';
import { ResponsiveTypography } from '@doltech/ui/lib/figma/Typography/v3/ResponsiveTypography';
import * as React from 'react';
import styled from 'styled-components';

interface OverallHeadingProps {
  title: string;
  onClose?: () => void;
}

const Main = styled.div`
  display: flex;
  .section-left {
    flex: 1;
  }
  .section-right {
    font-size: 48px;
    width: 24px;
  }
`;

export const OverallHeading = ({ title, onClose }: OverallHeadingProps) => {
  return (
    <Main className="overall-title">
      <div className="section-left">
        <ResponsiveTypography.Paragraph variant="SemiBold/20px | 28px" color="black100">
          {title}
        </ResponsiveTypography.Paragraph>
      </div>
      {onClose ? (
        <div className="section-right">
          <Button.Icon type="secondary" size="small" onClick={onClose}>
            <IconOtherClose fontSize={20} />
          </Button.Icon>
        </div>
      ) : null}
    </Main>
  );
};
